import { BaseHTTPClient } from "@/network/basehttpclient";
import {
  AuthenticationRequest,
  GetUserInfoRequest,
  ResendCodeRequest,
} from "@/network/httprequestentities/httpconfig";
import { IUserProfile } from "@/global/interfaces/httprequestinterface";
import { UserModel } from "@/models/usermodel";
import axiosconfigurator from "@/global/config/axiosconfiguartor";

export class AuthenticationRepository extends BaseHTTPClient {
  constructor() {
    super();
  }

  public async login(params: IUserProfile): Promise<UserModel | undefined> {
    try {
      const response = await this.request<any>(
        new AuthenticationRequest(params),
      );
      const userprofile = response?.result?.data?.css
        ? new UserModel(response.result.data.css)
        : null;

      if (!userprofile) {
        return;
      }
      this._setAuthToken(response.result.data.accessToken);
      return userprofile;
    } catch (error) {
      return;
    }
  }

  public async getUserInfo(): Promise<UserModel | undefined> {
    try {
      const response = await this.request<any>(new GetUserInfoRequest());
      return response?.result?.data;
    } catch (error) {
      return;
    }
  }

  public async resendCode(cssId: number): Promise<boolean> {
    try {
      await this.request<any>(new ResendCodeRequest(cssId));
      return true;
    } catch (error) {
      return false;
    }
  }

  private _setAuthToken(token: string) {
    // Save token to localstorage
    window.localStorage.setItem("token", token);
    // Config token
    axiosconfigurator._configAxiosToken(token, true);
  }
}

export let authenticationRepository = new AuthenticationRepository();
